export enum NewUserQuestionnaireEventType {
    SportsEvent = "SportsEvent",
    RoadEvent = "RoadEvent",
    FestivalOrParade = "FestivalOrParade",
    ExhibitionOrShow = "ExhibitionOrShow",
    MajorEvent = "MajorEvent",
    MultipleEvents = "MultipleEvents",
    Venue = "Venue",
    SomethingElse = "SomethingElse"
}